/**
 * Which filenames a browser can render itself, by extension.
 *
 * Everything else (.label, .doc, .xlsx, …) must be downloaded: handing a
 * non-previewable blob to window.open() or an <iframe> yields a blank or
 * blocked tab and never falls back to downloading, which reads to the user as
 * "clicking did nothing".
 */
export const PREVIEWABLE_EXTENSIONS = ['pdf', 'png', 'jpg', 'jpeg', 'gif', 'webp', 'txt', 'html', 'htm'];

export function isPreviewableFilename(fileName: string | null | undefined): boolean {
  if (!fileName) return false;
  const ext = fileName.includes('.') ? fileName.split('.').pop()!.toLowerCase() : '';
  return PREVIEWABLE_EXTENSIONS.includes(ext);
}
